<div style="
    position: fixed;
    width: 100%;
    height: 100%;
    text-align: center;
    z-index: 999999999999;
    background: white;
    top: 0;
    right: 0;
" *ngIf="!welcome">
  <!-- Logo -->
  <div class="logo">
    <img src="/assets/logo color.png" alt="Blue Box Logo">
  </div>

  <!-- Pets -->
  <div class="welcome-footer">
    <div class="pets">
      <img src="/assets/PRINT.png" alt="Dog and Cat">
    </div>

    <!-- Content -->
    <div class="content">
      <h2>{{ "welcometextb" | transloco }}</h2>
      <p>
        {{ "welcometextbb" | transloco }}
        <br>
        {{ "slogen" | transloco }}
      </p>
      <button class="btn" (click)="createAccount()"> {{"Create account from here" | transloco}}</button>
      <button class="btn" (click)="skipToHome()">{{ "Skip" | transloco }}</button>
    </div>
  </div>
</div>